import React from 'react'
import { Link } from 'react-router-dom'
import { HelpCircle, Mail, MessageSquareText } from 'lucide-react'
import MarketingSiteLayout from '../../marketing/MarketingSiteLayout'
import { PUBLIC_INQUIRY_PATH } from '../../marketing/marketingNav'
import { publicFaqExtendedItems } from '../../marketing/publicFaqExtended'

export default function SupportFaqPage() {
  return (
    <MarketingSiteLayout>
      <div className="relative overflow-hidden border-b border-slate-200 bg-white">
        <div className="absolute inset-0 bg-[linear-gradient(to_right,rgba(15,23,42,0.045)_1px,transparent_1px),linear-gradient(to_bottom,rgba(15,23,42,0.045)_1px,transparent_1px)] bg-[size:40px_40px]" />
        <div className="relative mx-auto grid max-w-6xl gap-10 px-4 py-14 md:grid-cols-[1fr_0.75fr] md:items-center md:py-20">
          <div>
            <nav className="text-sm text-slate-500">
              <Link to="/support" className="hover:text-brand-navy">
                FAQ
              </Link>
              <span className="mx-2">/</span>
              <span className="text-slate-800">자주 묻는 질문</span>
            </nav>
            <h1 className="mt-6 text-4xl font-black tracking-tight text-slate-900 sm:text-5xl">자주 묻는 질문</h1>
            <p className="mt-5 max-w-2xl text-base leading-7 text-slate-600 sm:text-lg">
              도입 전 자주 확인하는 질문을 모았습니다. 플랜, 계정, 조직 도입처럼 상황에 따라 달라지는 내용은
              문의로 남겨주시면 운영 방식에 맞춰 안내드립니다.
            </p>
          </div>
          <div className="rounded-lg border border-slate-200 bg-white/90 p-5 shadow-xl shadow-slate-200/80 backdrop-blur">
            <div className="grid gap-3">
              <div className="flex gap-4 rounded-lg bg-slate-50 p-4">
                <HelpCircle className="mt-0.5 h-5 w-5 shrink-0 text-brand-sky" aria-hidden="true" />
                <div>
                  <div className="text-sm font-bold text-slate-900">먼저 FAQ 확인</div>
                  <p className="mt-1 text-xs leading-5 text-slate-600">도입, 요금, 앱·웹 사용 방식에 대한 기본 답변을 확인합니다.</p>
                </div>
              </div>
              <div className="flex gap-4 rounded-lg bg-slate-50 p-4">
                <Mail className="mt-0.5 h-5 w-5 shrink-0 text-brand-sky" aria-hidden="true" />
                <div>
                  <div className="text-sm font-bold text-slate-900">도입 문의</div>
                  <p className="mt-1 text-xs leading-5 text-slate-600">가입 전 상담은 공개 문의로 접수합니다.</p>
                </div>
              </div>
              <div className="flex gap-4 rounded-lg bg-slate-50 p-4">
                <MessageSquareText className="mt-0.5 h-5 w-5 shrink-0 text-brand-sky" aria-hidden="true" />
                <div>
                  <div className="text-sm font-bold text-slate-900">고객문의</div>
                  <p className="mt-1 text-xs leading-5 text-slate-600">로그인 후 이용 문의는 비공개 고객문의에서 이어갑니다.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="mx-auto max-w-4xl px-4 py-14 md:py-20">
        <div className="divide-y divide-slate-200 rounded-lg border border-slate-200 bg-white shadow-sm">
          {publicFaqExtendedItems.map((item) => (
            <section key={item.question} className="px-6 py-6 sm:px-8">
              <h2 className="text-base font-bold text-slate-900">{item.question}</h2>
              <p className="mt-3 text-sm leading-7 text-slate-600">{item.answer}</p>
            </section>
          ))}
        </div>

        <div className="mt-10 rounded-lg bg-slate-950 px-6 py-7 text-white sm:flex sm:items-center sm:justify-between sm:gap-6">
          <div>
            <h2 className="text-lg font-black">원하는 답을 찾지 못하셨나요?</h2>
            <p className="mt-2 text-sm leading-6 text-slate-300">도입 전 문의는 공개 문의로, 이용 중 문의는 고객문의로 남겨주세요.</p>
          </div>
          <div className="mt-5 flex flex-wrap gap-2 sm:mt-0 sm:shrink-0">
            <Link
              to={PUBLIC_INQUIRY_PATH}
              className="inline-flex min-h-[42px] items-center justify-center rounded-lg bg-white px-5 text-sm font-bold text-brand-navy hover:bg-sky-50"
            >
              도입 문의
            </Link>
            <Link
              to="/support/inquiries"
              className="inline-flex min-h-[42px] items-center justify-center rounded-lg border border-white/30 px-5 text-sm font-bold text-white hover:bg-white/10"
            >
              고객문의
            </Link>
          </div>
        </div>
      </div>
    </MarketingSiteLayout>
  )
}
